import React from 'react';
import {useRouteMatch, Switch, Route} from 'react-router-dom';
import SideBar from '../components/SideBar';
import {useMediaQuery} from 'react-responsive';
import styles from './styles.module.css';
import AgencyRquests from '../pages/Admin/AgencyRquests';
import PermitRquests from '../pages/Admin/PermitRquests';
import {adminTabs} from './tabs';

/**
 * @return {JSX.Element}
 */
function AdminRouter(props) {
  const {url} = useRouteMatch();
  console.info('url', url);
  const isMobile = useMediaQuery({maxWidth: 767});

  const onProfileClick = () => {
    const {history} = props;
    history.push(`${url}/profile`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        {!isMobile ? (
          <div className={styles.sideBar}>
            <SideBar
              module={'admin'}
              header={'Permit Requests'}
              tabs={adminTabs}
            />
          </div>
        ) : null}
        <div className={styles.relative}>
          <div className={styles.bodyWrapper}>
            <Switch>
              <Route path={`${url}/agencyRequests`}>
                <AgencyRquests />
              </Route>
              <Route path={`${url}/permitRequests`}>
                <PermitRquests />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminRouter;
